import AddIcon from "@material-ui/icons/Add";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/EditOutlined";
import { Business } from "@material-ui/icons";
import { FieldArray } from "formik";
import { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import fetchClient from "../../api/fetchClient";
import message from "../../helper/message";
import AddModal from "./AddModal";

function TabEmpresa({ values, errors, handleChange, touched, initialValues }) {
	const [options, setOptions] = useState([]);
	const [showAdd, setShowAdd] = useState(false);
	const [addValue, setAddValue] = useState(null);

	const empresa = values.empresa ? values.empresa : [];
	const maxEmpresas = values.maxEmpresas ? values.maxEmpresas : 0;
	console.log("values", values);
	const fields = [
		{
			name: "empresa",
			label: "Empresa",
			component: "select",
			options: options,
		},
		{
			name: "documento",
			label: "Tipo Doc. expense",
			component: "select",
			options: [
				{ value: "30", label: "Lançamento contábil" },
				{ value: "18", label: "Nota Fiscal de Entrada" },
			],
		},
		{
			name: "filterBp",
			label: "Filtrar PN por",
			component: "text",
		},
		{
			name: "sequence",
			label: "Seq. NF",
			component: "text",
		},
		{
			name: "usage",
			label: "Usage NF",
			component: "text",
		},
		{
			name: "usageAdto",
			label: "Usage Adto",
			component: "text",
		},
		{
			name: "itemCodeAdto",
			label: "Item Adto",
			component: "text",
		},
		{
			name: "sequenceDev",
			label: "Seq. Devolução NF",
			component: "text",
		},
		{
			name: "usageDev",
			label: "Usage Devolução NF",
			component: "text",
		},
		{
			name: "itemCodeDevAdto",
			label: "Item Devolução Adto",
			component: "text",
		},
		{
			name: "fieldToInvoice",
			label: "Considerar Campo para Data Lcto",
			component: "select",
			options: [
				{
					value: "reportPaymentProcessingDate",
					label: "reportPaymentProcessingDate",
				},
				{ value: "reportCreationDate", label: "reportCreationDate" },
			],
		},

		{
			name: "sendAttachments",
			label: "Enviar anexos",
			component: "check",
		},
	];

	async function getAllEmpresas() {
		try {
			let allData = [];
			let nextToken = null;

			do {
				const { data } = await fetchClient.get(`getAllAplicacao?limit=100${nextToken ? `&nextToken=${nextToken}` : ''}`);
				allData = [...allData, ...data.value];
				nextToken = data.nextToken;
			} while (nextToken);

			const aplicacoes = allData.map((app) => {
				return { value: app.id, label: app.description };
			});
			setOptions(aplicacoes);
		} catch (error) {
			console.error("Erro ao buscar empresas:", error);
			message.error("Erro ao buscar empresas");
		}
	}

	function findBusinessName(id) {
		const app = options.find((app) => app.value === id);
		return app ? app.label : "";
	}

	function findDocName(id) {
		const docOptions = fields.find((item) => item.name === "documento").options;
		const doc = docOptions.find((doc) => doc.value === id);
		return doc ? doc.label : "";
	}

	useEffect(() => {
		getAllEmpresas();
	}, []);

	return (
		<ModernFormContainer>
			{showAdd && (
				<AddModal show={setShowAdd} fields={fields} values={addValue} />
			)}
			<SectionCard>
				<SectionHeader>
					<SectionIcon color="#3498db">
						<Business />
					</SectionIcon>
					<SectionTitle>Empresas Vinculadas</SectionTitle>
				</SectionHeader>
				<FieldArray name="empresa">
					{({ push, remove }) => (
						<>
							<TableWrapper>
								<ModernTable>
									<thead>
										<TableHeaderRow>
											<TableHead>Empresa</TableHead>
											<TableHead>Tipo doc. expense</TableHead>
											<TableHead align="right">Ações</TableHead>
										</TableHeaderRow>
									</thead>
									<tbody>
										{empresa.length === 0 ? (
											<EmptyRow>
												<EmptyCell colSpan={3}>
													<EmptyState>
														<Business style={{ fontSize: '48px', color: '#cbd5e1', marginBottom: '8px' }} />
														<EmptyText>Nenhuma empresa vinculada</EmptyText>
														<EmptySubtext>Adicione empresas para começar</EmptySubtext>
													</EmptyState>
												</EmptyCell>
											</EmptyRow>
										) : (
											empresa.map((value, index) => (
												<TableRow key={index}>
													<TableCell>{findBusinessName(value.empresa)}</TableCell>
													<TableCell>{findDocName(value.documento)}</TableCell>
													<TableActions>
														<ActionButton
															variant="edit"
															onClick={(e) => {
																e.preventDefault();
																setShowAdd(true);
																setAddValue(value);
															}}
														>
															<EditIcon style={{ fontSize: '18px' }} />
														</ActionButton>
														<ActionButton
															variant="delete"
															onClick={(e) => {
																e.preventDefault();
																remove(index);
															}}
														>
															<DeleteOutlineIcon style={{ fontSize: '18px' }} />
														</ActionButton>
													</TableActions>
												</TableRow>
											))
										)}
									</tbody>
								</ModernTable>
							</TableWrapper>
							<ButtonContainer>
								<AddButton
									onClick={(e) => {
										e.preventDefault();
										if (maxEmpresas > 0 && empresa.length >= maxEmpresas) {
											message.error(
												`Número máximo de empresas atingido: ${maxEmpresas}`
											);
											return;
										}
										push({});
									}}
								>
									<AddIcon style={{ marginRight: '8px' }} />
									Adicionar Empresa
								</AddButton>
							</ButtonContainer>
						</>
					)}
				</FieldArray>
			</SectionCard>
		</ModernFormContainer>
	);
}

export default TabEmpresa;

// Animações
const fadeIn = keyframes`
	from {
		opacity: 0;
		transform: translateY(10px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
`;

const ModernFormContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	font-family: 'Mulish', sans-serif;
`;

const SectionCard = styled.div`
	background: white;
	border-radius: 16px;
	padding: 24px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
	border: 1px solid #e8e8e8;
	animation: ${fadeIn} 0.5s ease;
	transition: all 0.3s ease;

	&:hover {
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
		border-color: #d0d0d0;
	}
`;

const SectionHeader = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 20px;
	padding-bottom: 16px;
	border-bottom: 2px solid #f0f0f0;
`;

const SectionIcon = styled.div`
	width: 40px;
	height: 40px;
	border-radius: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: ${props => props.color ? `${props.color}15` : '#667eea15'};
	color: ${props => props.color || '#667eea'};
	margin-right: 12px;
	transition: all 0.3s ease;

	svg {
		font-size: 22px;
	}

	${SectionCard}:hover & {
		transform: scale(1.1);
	}
`;

const SectionTitle = styled.h3`
	font-size: 18px;
	font-weight: 700;
	color: #2c3e50;
	margin: 0;
	font-family: 'Mulish', sans-serif;
`;

const TableWrapper = styled.div`
	width: 100%;
	overflow-x: auto;
	margin-bottom: 20px;
`;

const ModernTable = styled.table`
	width: 100%;
	border-collapse: collapse;
	min-width: 600px;
`;

const TableHeaderRow = styled.tr`
	background: #f8f9fa;
	border-radius: 8px;
`;

const TableHead = styled.th`
	text-align: ${props => props.align || 'left'};
	padding: 12px 16px;
	font-size: 13px;
	font-weight: 600;
	color: #6b7280;
	text-transform: uppercase;
	letter-spacing: 0.5px;
	border-bottom: 2px solid #e5e7eb;
	font-family: 'Mulish', sans-serif;
`;

const TableRow = styled.tr`
	border-bottom: 1px solid #eef2f7;
	transition: all 0.2s ease;

	&:hover {
		background: #f9fbff;
	}
`;

const TableCell = styled.td`
	padding: 12px 16px;
	color: #4c5968;
	font-size: 14px;
	font-family: 'Mulish', sans-serif;
`;

const TableActions = styled.td`
	padding: 12px 16px;
	text-align: right;
	display: flex;
	gap: 8px;
	justify-content: flex-end;
`;

const ActionButton = styled.button`
	border: none;
	border-radius: 8px;
	width: 36px;
	height: 36px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	transition: all 0.3s ease;
	${({ variant }) =>
		variant === 'edit'
			? `
			background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
			color: white;
			&:hover {
				box-shadow: 0 4px 12px rgba(52, 152, 219, 0.4);
				transform: translateY(-2px);
			}
		`
			: `
			background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
			color: white;
			&:hover {
				box-shadow: 0 4px 12px rgba(231, 76, 60, 0.4);
				transform: translateY(-2px);
			}
		`}

	&:active {
		transform: translateY(0);
	}
`;

const ButtonContainer = styled.div`
	display: flex;
	justify-content: flex-start;
	margin-top: 16px;
`;

const AddButton = styled.button`
	background: linear-gradient(135deg, #27ae60 0%, #229954 100%);
	color: white;
	border: none;
	border-radius: 12px;
	padding: 12px 24px;
	font-size: 14px;
	font-weight: 600;
	cursor: pointer;
	display: flex;
	align-items: center;
	transition: all 0.3s ease;
	font-family: 'Mulish', sans-serif;
	box-shadow: 0 4px 12px rgba(39, 174, 96, 0.3);

	&:hover {
		transform: translateY(-2px);
		box-shadow: 0 6px 16px rgba(39, 174, 96, 0.4);
	}

	&:active {
		transform: translateY(0);
	}
`;

const EmptyRow = styled.tr``;

const EmptyCell = styled.td`
	padding: 48px 24px;
`;

const EmptyState = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	font-family: 'Mulish', sans-serif;
`;

const EmptyText = styled.h4`
	font-size: 18px;
	font-weight: 600;
	color: #2c3e50;
	margin: 0 0 4px 0;
	font-family: 'Mulish', sans-serif;
`;

const EmptySubtext = styled.p`
	font-size: 14px;
	color: #7f8c8d;
	margin: 0;
	font-family: 'Mulish', sans-serif;
`;
